<template>
  <div class="mx-3">
    <v-row>
      <v-col
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <setup-job-position-job-grade-dialog-create
          v-if="$hasPermissionTo(['create job grades'])" 
          @created="loadData"
        />
      </v-col>
      <v-spacer />

      <v-col
        class="py-0"
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <v-select
          v-model="statusFilter"
          :items="items"
          item-text="state"
          item-value="value"
          label="Job Grade Code's Status"
          placeholder="Active / Deleted"
        />
      </v-col>

      <v-col
        class="py-0"
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <v-text-field
          v-model="search"
          placeholder="Key in job grade code here"
          append-icon="search"
          label="Search Job Grade Code"
          hide-no-data
          hide-selected
          clearable 
        />
      </v-col>
    </v-row>

    <v-data-table
      :headers="headers"
      :items="filteredJobBands"
      :loading="tableLoading"
      :search="search"
    >
      <template v-slot:item.job_group.name="{ item }">
        <div>
          <span>
            {{ item.job_group.name }}
          </span>
        </div>
      </template>

      <template v-slot:item.job_category.name="{ item }">
        <div>
          <span>
            {{ item.job_category.name }}
          </span>
        </div>
      </template>

      <template v-slot:item.job_band.value="{ item }">
        <div>
          <span>
            {{ (item.job_band||{}).value }}
          </span>
        </div>
      </template>

      <template v-slot:item.salary_from="{ item }">
        <div>
          <span>
            {{ roundTwoDecimal(item.salary_from) }}
          </span>
        </div>
      </template>

      <template v-slot:item.salary_to="{ item }">
        <div>
          <span>
            {{ roundTwoDecimal(item.salary_to) }}
          </span>
        </div>
      </template>

      <template v-slot:item.action="{ item }">
        <span v-if="statusFilter">
          <setup-job-position-job-grade-dialog-edit
            v-if="$hasPermissionTo(['update job grades'])" 
            :job-grade="item"
            @updated="loadData"
          />
          <span class="mx-1" />
          <setup-job-position-job-grade-dialog-delete
            v-if="$hasPermissionTo(['delete job grades'])" 
            :job-grade="item"
            @deleted="loadData"
          />
        </span>
        <span v-else>
          <setup-job-position-job-grade-dialog-restore
            v-if="$hasPermissionTo(['restore job grades'])" 
            :job-grade="item"
            @restored="loadData"
          />
        </span>
      </template>
    </v-data-table> 
  </div>
</template>

<script>
  export default {
    components: {
      SetupJobPositionJobGradeDialogCreate: () => import('@/components/hris/setup/job-position/job-grade/DialogCreate'),
      SetupJobPositionJobGradeDialogDelete: () => import('@/components/hris/setup/job-position/job-grade/DialogDelete'),
      SetupJobPositionJobGradeDialogRestore: () => import('@/components/hris/setup/job-position/job-grade/DialogRestore'),
      SetupJobPositionJobGradeDialogEdit: () => import('@/components/hris/setup/job-position/job-grade/DialogEdit'),
    },
    data () {
      return {
        jobGrades: [],
        trashedJobGrades: [],
        headers: [
          {
            text: 'Name',
            align: 'left',
            value: 'name',
          },
          {
            text: 'Job Group',
            align: 'center',
            value: 'job_group.name',
          },
          {
            text: 'Job Category',
            align: 'center',
            value: 'job_category.name',
          },
          {
            text: 'Job Band/Grade',
            align: 'center',
            value: 'job_band.value',
          },
          {
            text: 'Salary From (RM)',
            align: 'right',
            sortable: false,
            value: 'salary_from',
          },
          {
            text: 'Salary To (RM)',
            align: 'right',
            sortable: false,
            value: 'salary_to',
          },
          {
            text: '',
            sortable: false,
            value: 'action',
          },
        ],
        search: '',
        statusFilter: { state: 'Active', value: true },
        items: [
          { state: 'Active', value: true },
          { state: 'Deleted', value: false },
        ],
        tableLoading: true,
      }
    },
    computed: {
      filteredJobBands () {
        return this.statusFilter ? this.jobGrades : this.trashedJobGrades
      },
    },
    created () {
      this.loadData()
    },
    methods: {
      loadData () {
        Promise.all([
          this.$api.jobGrades().list(),
          this.$api.jobGrades().listTrashed(),
        ]).then(([jobGrades, trashedJobGrades]) => {
          this.jobGrades = jobGrades.data
          this.trashedJobGrades = trashedJobGrades.data

          this.tableLoading = false
        })
      },
      roundTwoDecimal (value) {
        return (Math.round((value / 100) * 100) / 100).toFixed(2)
      },
    },
  }
</script>
